import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlatformApiService } from '../services/platform-api.service';
import { GridSpinnerComponent } from './grid-spinner.component';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-buynow-prompt',
  templateUrl: './buynow-prompt.component.html',
  styleUrls: ['./buynow-prompt.component.scss']
})
export class BuyNowPromptComponent implements OnInit {
  @ViewChild('spinner') spinner: GridSpinnerComponent;

  constructor(public dialogRef: MatDialogRef<BuyNowPromptComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }
}
